import React, { useState, useContext } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import { NavLink as RRNavLink, Link } from 'react-router-dom';

import { AuthContext } from '../../../Data/AuthContext';

function NavigationBarAdmin(props) {
    const [isOpen, setIsOpen] = useState(false);
    const auth = useContext(AuthContext);

    const { isAuthenticated, name } = auth;

    return (
        <Navbar color="primary" dark expand="lg">
            <NavbarBrand>VIK Szakestély - Admin</NavbarBrand>
            <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <NavLink tag={RRNavLink} to="/admin/events">Rendezvények</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={RRNavLink} to="/admin/news">Hírek</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={RRNavLink} to="/admin/pages">Lapok</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={RRNavLink} to="/admin/users">Felhasználók</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={RRNavLink} to="/">Vissza a főoldalra</NavLink>
                    </NavItem>
                    {isAuthenticated &&
                        <NavItem>
                            <NavLink tag={Link} to="/" onClick={auth.logout}>Kijelentkezés ({name})</NavLink>
                        </NavItem>
                    }
                </Nav>
            </Collapse>
        </Navbar>
    );
}

export default NavigationBarAdmin;